import { createPopper } from '@popperjs/core';
import type { TooltipProps } from '../types/props';
import Tooltip from '../elements/Tooltip.svelte';

export const tooltipAction = (
	node: Element,
	params: TooltipProps
): { update?(newParams: any): void; destroy(): void } => {
	const { title, content, id = 'hover-tooltip', placement = 'top' } = params || {};

	if (!title && !content)
		return {
			destroy: () => {
				return;
			}
		};

	let popperInstance;
	let svelteTooltip: Tooltip;

	const show = () => {
		svelteTooltip = new Tooltip({
			props: {
				title: params.title ?? title,
				content: params.content ?? content,
				placement: params.placement ?? placement,
				id: params.id ?? id
			},
			target: document.body
		});

		const tooltipElement = document.getElementById(id) as HTMLElement;

		popperInstance = createPopper(node, tooltipElement, {
			placement,
			modifiers: [
				{
					name: 'offset',
					options: {
						offset: [0, 16]
					}
				},
				{ name: 'eventListeners', enabled: true }
			]
		});

		popperInstance.update();
	};

	const hide = () => {
		if (popperInstance) {
			popperInstance.setOptions({
				modifiers: [{ name: 'eventListeners', enabled: false }]
			});
			popperInstance.destroy();
			popperInstance = null;
		}

		if (svelteTooltip) {
			svelteTooltip.$destroy();
		}
	};

	node.addEventListener('mouseenter', show);
	node.addEventListener('mouseleave', hide);

	return {
		update(newParams: any) {
			params = newParams;
			hide();
		},
		destroy() {
			node.removeEventListener('mouseover', show);
			node.removeEventListener('mouseout', hide);
		}
	};
};
